module.exports = __webpack_public_path__ + "img/google-cloud.50aaf86c.svg";